import api from './api';

export const dashboardService = {
  /**
   * Obter dados do dashboard
   */
  getData: async ({ startDate, endDate } = {}) => {
    const response = await api.get('/dashboard', { params: { startDate, endDate } });
    return response;
  },

  /**
   * Obter saldo atual
   */
  getCurrentBalance: async () => {
    const response = await api.get('/balances/current');
    return response;
  },

  /**
   * Obter saldo projetado
   */
  getProjectedBalance: async (months = 3) => {
    const response = await api.get('/balances/projected', {
      params: { months },
    });
    return response;
  },
};

export default dashboardService;
